import { http, persistFromResult } from '@/api/client/httpClient';
import type {
  AuthenticateModel,
  AuthenticateResultModel,
  RefreshTokenModel,
  VerifyTwoFactorModel,
} from '@/api/types/account';

// Routes derived from ABP conventional-controller mapping of
// Finkit.Account.AccountSessionAppService (verb from method-name prefix; name
// kebab-cased). Verified against /api/abp/api-definition when the backend runs.
const BASE = '/api/app/account-session';

export const accountSessionApi = {
  async authenticate(input: AuthenticateModel): Promise<AuthenticateResultModel> {
    const { data } = await http.post<AuthenticateResultModel>(`${BASE}/authenticate`, input);
    persistFromResult(data);
    return data;
  },

  async verifyTwoFactor(input: VerifyTwoFactorModel): Promise<AuthenticateResultModel> {
    const { data } = await http.post<AuthenticateResultModel>(`${BASE}/verify-two-factor`, input);
    persistFromResult(data);
    return data;
  },

  async refreshToken(input: RefreshTokenModel): Promise<AuthenticateResultModel> {
    const { data } = await http.post<AuthenticateResultModel>(`${BASE}/refresh-token`, input);
    persistFromResult(data);
    return data;
  },

  async impersonate(targetUserId: string): Promise<AuthenticateResultModel> {
    const { data } = await http.post<AuthenticateResultModel>(`${BASE}/impersonate`, {
      targetUserId,
    });
    persistFromResult(data);
    return data;
  },

  // Host "Login as tenant admin": the backend resolves the tenant's admin and issues a
  // bearer impersonation token (cross-tenant). Same client-side token-swap as impersonate().
  async impersonateTenant(tenantId: string): Promise<AuthenticateResultModel> {
    const { data } = await http.post<AuthenticateResultModel>(`${BASE}/impersonate-tenant`, {
      tenantId,
    });
    persistFromResult(data);
    return data;
  },

  async logout(): Promise<void> {
    await http.post(`${BASE}/logout`);
  },
};
